import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Container, Col, Row, Alert } from 'reactstrap';
import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Upload, Divider } from 'antd';
import { Document, Page } from 'react-pdf';

// Local Deps
import { s3SupportDocs } from '../../config/properties';

import './UploadTooling.scss';
// DONT REMOVE import uploadToolingHelp from '../../HelpFiles/Tooling Information Upload Example and Instructions.pdf';
import UploadToolingHOC from './UploadToolingHOC';
import msgs from '../../config/messages';
// import uploadToolingTemplate from '../../HelpFiles/ToolingManagementDataTemplate.csv';
// import uploadToolingHelp from '../../HelpFiles/Tooling Information Upload Example and Instructions.pdf';

const uploadToolingTemplate = `${s3SupportDocs}/ToolingAndInventory/ToolingManagementDataTemplate.csv`;
const uploadToolingHelp = `${s3SupportDocs}/ToolingAndInventory/Tooling Information Upload Example and Instructions.pdf`;

const { Dragger } = Upload;

// const HelpOver = (
//   <span>
//     <p>You will need to format your files. Click here for more information</p>
//   </span>
// );
class UploadTooling extends Component {
  static propTypes = {
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    hideMessage: PropTypes.func.isRequired,
    handleUpload: PropTypes.func.isRequired,
    onReturnToMainPage: PropTypes.func.isRequired,
  };

  static initialState = {};

  state = UploadTooling.initialState;

  render() {
    const {
      alertType,
      alertMessage,
      hideMessage,
      handleUpload,
    } = this.props;

    return (
      <div className="nf-add-tool">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Upload Tooling Page</title>
        </Helmet>
        <Container>
          <Col sm={12}>
            <br />
            {/* DONT DELETE BELOW */}
            {/* <Row
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <h3 style={{ fontWeight: 400, marginLeft: '40px' }}>
                Upload Tooling
              </h3>
              <Col xs="auto" className="upload-products-header">
                <Popover placement="rightTop" content={HelpOver}>
                  <a href={uploadToolingHelp} target="_blank">
                    <Button
                      style={{
                        backgroundColor: '#ff7c52',
                        color: 'white',
                        border: 'none',
                      }}
                      size="small"
                      shape="circle"
                    >
                      ?
                    </Button>
                  </a>
                </Popover>
              </Col>
            </Row> */}
            <br />
            <Dragger
              accept=".csv,.xlsx,.xls"
              customRequest={handleUpload}
              showUploadList={false}
            >
              <p style={{ fontSize: '48px', color: '#ff7c52' }}>
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                <ul>
                  <ul>
                    {' '}
                    Once you select a file, the upload process will begin
                    immediately. Please make sure that the file you selected is
                    the correct one and that is 200 rows or less or 10kb.
                  </ul>
                  <ul>
                    In order for your file to be processed correctly, you may
                    need to format it.
                  </ul>
                  <ul><u>Only .csv, .xlsx, and .xls files will be processed</u></ul>
                </ul>
              </p>

            </Dragger>

            <Col xs="auto">
              {/* <Row
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                }}
              >
                <Alert color="light" style={{ fontSize: '.75rem' }} />
              </Row> */}
              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                }}
              >
                {alertMessage && (
                  <Alert color={alertType} toggle={hideMessage}>
                    {alertMessage}
                  </Alert>
                )}
              </Row>
              <Row
                style={{
                  // 'margin-left': '15vw',
                  display: 'block',
                  textAlign: 'left',
                  marginTop: '20px',
                }}
              >
                <p>1. The uploaded file must be in the same format as the downloaded file. Download the template here:
                  <a href={uploadToolingTemplate} target="_blank">
                    <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                      Tooling Template
                    </Button>
                  </a>
                </p>
                <p>2. Save the file as comma-separated values (*.csv). </p>
                <p>For files bigger than 200 rows Using Excel
                  <ol>
                    <li>Open your CSV file in Excel</li>
                    <li>Select rows 2-201 (first 200 data rows + header)</li>
                    <li>Copy and paste into a new Excel file</li>
                    <li>Save as `Template_Part1.csv` for example</li>
                    <li>Repeat for rows 202-401, 402-601, etc.</li>
                    <li>Make sure each file includes the header row</li>
                  </ol>
                </p>
                <p>3. Please follow the direction of the PDF Help File provided below.  Click here to download the file:
                  <a href={uploadToolingHelp} target="_blank">
                    <Button icon={<DownloadOutlined />} primary className='ndaBtns'>
                      PDF Help File
                    </Button>
                  </a>
                </p>
                <p>4. Records will not show if the .csv file is not configured to the template and directions given on the PDF help file.</p>
                <p>5. Your Tooling records will be completely overlaid with this file, but Inventory management records with the same Part Number and NSN will not be affected.</p>
                <p>6. Files are processed immediately - you will see results right away without waiting for batch processing.</p>
              </Row>


            </Col>
          </Col>

          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            {/* <embed src={`${uploadToolingHelp}#toolbar=0&navpanes=0&scrollbar=0&zoom=100`} type="application/pdf" width="834px" height="1107px" /> */}
            {/* <iframe src={`${uploadToolingHelp}#toolbar=0&navpanes=0&scrollbar=0&zoom=100`} height="1107" width="834" title="Upload Tooling Help" /> */}
            <a href={uploadToolingHelp} target="_blank">
              <Document
                file={uploadToolingHelp}
              >
                <Page pageNumber={1} />
              </Document>
            </a>
          </Row>
          <Divider />
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <Button
              key="back"
              className="nf-button nf-button--gray-border"
              style={{ marginBottom: '20px' }}
              onClick={this.props.onReturnToMainPage}
            >
              {msgs.Form.cancelButton}
            </Button>
          </Row>

        </Container>
      </div>
    );
  }
}

export default UploadToolingHOC(UploadTooling);



// WEBPACK FOOTER //
// ./src/components/UploadTooling/UploadTooling.jsx